import React from 'react';
import { Field } from 'react-final-form';
import styles from './AdminChatForm.module.scss';
import TopKInput from './TopKInput';
import TraceTagInput from './TraceTagInput';
import { FormValues } from '../../../../../store/chat/types';
import { useAppDispatch } from '../../../../../store/hooks';
import { updateFormValues } from '../../../../../store/chat/slice';
import { RAGMode } from '../../../../../types/RAGModes';
import RAGSelector from './RAGSelector';
import ModelSelector from '../../../../ModelSelector';
import { AIModel } from '../../../../../types/AIModels';
import { QueryType } from '../../../../../types/QueryTypes';
import QueryTypeSelector from './QueryTypeSelector';
import RelevanceInput from './RelevanceInput';

interface FormContentProps {
  values: FormValues;
}

const AdminChatForm: React.FC<FormContentProps> = ({ values }) => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(updateFormValues(values));
  }, [values, dispatch]);

  return (
    <div className={styles.chatControls}>
      <div className={styles.controlRow}>
        <div className={styles.controlGroup}>
          <Field<AIModel> name="model">
            {({ input }) => <ModelSelector model={input.value} onChange={input.onChange} />}
          </Field>
        </div>

        <div className={styles.controlGroup}>
          <Field<number> name="topK">
            {({ input }) => <TopKInput topK={input.value} onChange={input.onChange} />}
          </Field>
        </div>

        <div className={styles.controlGroup}>
          <Field<string> name="traceTag">
            {({ input }) => <TraceTagInput traceTag={input.value} onChange={input.onChange} />}
          </Field>
        </div>
      </div>

      <div className={styles.controlRow}>
        <div className={styles.controlGroup}>
          <Field<RAGMode> name="ragMode">
            {({ input }) => <RAGSelector ragMode={input.value} onChange={input.onChange} />}
          </Field>
        </div>

        <div className={styles.controlGroup}>
          <Field<number | undefined> name="relevancePercent">
            {({ input }) => (
              <RelevanceInput relevancePercent={input.value} onChange={input.onChange} />
            )}
          </Field>
        </div>

        <div className={styles.controlGroup}>
          <Field<QueryType | undefined> name="forceQueryType">
            {({ input }) => <QueryTypeSelector workflow={input.value} onChange={input.onChange} />}
          </Field>
        </div>
      </div>
    </div>
  );
};

export default AdminChatForm;
